export default "__VITE_PUBLIC_ASSET__0f78b644__"